import { render, staticRenderFns } from "./OutpatientIndex.vue?vue&type=template&id=155684e3&scoped=true"
import script from "./OutpatientIndex.vue?vue&type=script&lang=js"
export * from "./OutpatientIndex.vue?vue&type=script&lang=js"
import style0 from "./OutpatientIndex.vue?vue&type=style&index=0&id=155684e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155684e3",
  null
  
)

export default component.exports